import { GetServerSideProps } from 'next';
import { NavBarContent } from '@/components/Navbar';
import { api } from '@/services/api';
import CustomSearch from '@/components/Navbar/CustomSearch';
import Layout from '@/components/Layout';
import { HeadTags } from '@/shared/types/home.types';
import SearchSSR from '../../components/Navbar/CustomSearch/metatags';

interface NavBarContentData {
  data: NavBarContent;
}

interface SearchProps {
  navBarData: NavBarContent;
  query?: string;
}

export default function Search({ navBarData, query }: SearchProps) {
  return (
    <Layout layoutData={{ tagsData: SearchSSR as HeadTags[], navBarData }}>
      <CustomSearch query={query || ''} />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  const query = typeof context.query.q === 'string' && context.query.q;
  const responseMenu = await api.get<NavBarContentData>(`/componentes/menu/`);
  const navBarData = responseMenu.data.data;

  const expiration = new Date();
  expiration.setTime(new Date().getTime() + 120000);

  context.res.setHeader('Cache-Control', 'max-age=120, stale-while-revalidate=120');
  context.res.setHeader('Expires', expiration.toUTCString());
  context.res.statusCode = 200;

  return {
    props: {
      navBarData,
      query,
    },
  };
};
